export default __webpack_public_path__ + "static/media/ext-path.325f6c1f.svg";